import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { InviteService } from '../../services'

const STORAGE_KEY = 'inviteId'

export const InviteLanding = () => {
  const location = useLocation()

  useEffect(() => {
    const syncInviteFromUrl = async () => {
      const inviteId = InviteService.getInviteFromUrl()

      if (!inviteId) {
        return
      }

      window.localStorage.setItem(STORAGE_KEY, inviteId)

      const invite = await InviteService.validateInvite(inviteId)

      if (invite?.exists && invite?.status === 'active') {
        return
      }

      window.localStorage.removeItem(STORAGE_KEY)
    }

    syncInviteFromUrl()
  }, [location.search])

  return null
}
